/**
 * @generated SignedSource<<f3773af2ceb9c1be098d6a8cf2bfc354>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditMyBusinessDataInput = {
  businessData: BusinessDataInput;
  clientMutationId?: string | null;
};
export type BusinessDataInput = {
  bic?: string | null;
  employerNumber?: string | null;
  iban?: string | null;
  insuranceNumber?: string | null;
  taxNumber?: string | null;
};
export type personnelSheetTab_editMyBusinessDataMutation$variables = {
  input: EditMyBusinessDataInput;
};
export type personnelSheetTab_editMyBusinessDataMutation$data = {
  readonly Coaching: {
    readonly editMyBusinessData: {
      readonly coachProfile: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"personnelSheetTab_CoachProfileFragment" | "profileTab_CoachProfileFragment">;
      };
    } | null;
  };
};
export type personnelSheetTab_editMyBusinessDataMutation = {
  response: personnelSheetTab_editMyBusinessDataMutation$data;
  variables: personnelSheetTab_editMyBusinessDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "personnelSheetTab_editMyBusinessDataMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CoachingMutations",
        "kind": "LinkedField",
        "name": "Coaching",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "EditMyBusinessDataPayload",
            "kind": "LinkedField",
            "name": "editMyBusinessData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CoachProfile",
                "kind": "LinkedField",
                "name": "coachProfile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "personnelSheetTab_CoachProfileFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "profileTab_CoachProfileFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "personnelSheetTab_editMyBusinessDataMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CoachingMutations",
        "kind": "LinkedField",
        "name": "Coaching",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "EditMyBusinessDataPayload",
            "kind": "LinkedField",
            "name": "editMyBusinessData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CoachProfile",
                "kind": "LinkedField",
                "name": "coachProfile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileData",
                    "kind": "LinkedField",
                    "name": "profileData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileDataSocials",
                        "kind": "LinkedField",
                        "name": "socials",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkedIn",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "facebook",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "twitter",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "website",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "others",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobTitles",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "quote",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "File",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnail",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileDataBasicPersonal",
                        "kind": "LinkedField",
                        "name": "basicPersonal",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "salutation",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phoneNumber",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "certificateAnswer",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "File",
                        "kind": "LinkedField",
                        "name": "certificateFileIds",
                        "plural": true,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "coachingStrongPointsTopics",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "digitalAffinity1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "digitalAffinity2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "educationFreeText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "educationMoreThan150h",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "languages",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "methods",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personalPhilosophyCoachingStyle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personalPhilosophyVisionMission",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "referencesPublications",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "File",
                        "kind": "LinkedField",
                        "name": "referencesCoachingExperienceIds",
                        "plural": true,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "studies",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileDataExperience",
                        "kind": "LinkedField",
                        "name": "experience",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "branches",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "branchesSteps",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "coachingFileIds",
                            "plural": true,
                            "selections": (v3/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "coachingHours",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BusinessData",
                    "kind": "LinkedField",
                    "name": "businessData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taxNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "insuranceNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "iban",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bic",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BaseData",
                    "kind": "LinkedField",
                    "name": "baseData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nationality",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "gender",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "birthPlace",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "birthDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "city",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "postalCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lineOne",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lineTwo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "23bb354503d5026e03f9b93e935db7a3",
    "id": null,
    "metadata": {},
    "name": "personnelSheetTab_editMyBusinessDataMutation",
    "operationKind": "mutation",
    "text": "mutation personnelSheetTab_editMyBusinessDataMutation(\n  $input: EditMyBusinessDataInput!\n) {\n  Coaching {\n    editMyBusinessData(input: $input) {\n      coachProfile {\n        id\n        ...personnelSheetTab_CoachProfileFragment\n        ...profileTab_CoachProfileFragment\n      }\n    }\n  }\n}\n\nfragment personnelSheetTab_CoachProfileFragment on CoachProfile {\n  profileData {\n    socials {\n      linkedIn\n      facebook\n      twitter\n      website\n      others\n    }\n    description\n    jobTitles\n    quote\n    avatar {\n      id\n      url\n      thumbnail\n    }\n    basicPersonal {\n      lastName\n      firstName\n      title\n      salutation\n      email\n      phoneNumber\n    }\n    certificateAnswer\n    certificateFileIds {\n      id\n      name\n    }\n    coachingStrongPointsTopics\n    digitalAffinity1\n    digitalAffinity2\n    educationFreeText\n    educationMoreThan150h\n    languages\n    methods\n    personalPhilosophyCoachingStyle\n    personalPhilosophyVisionMission\n    referencesPublications\n    referencesCoachingExperienceIds {\n      id\n      name\n    }\n    studies\n    experience {\n      branches\n      branchesSteps\n      coachingFileIds {\n        id\n        name\n      }\n      coachingHours\n    }\n  }\n  businessData {\n    taxNumber\n    insuranceNumber\n    iban\n    employerNumber\n    bic\n  }\n  baseData {\n    nationality\n    gender\n    birthPlace\n    birthDate\n    address {\n      city\n      postalCode\n      lineOne\n      lineTwo\n    }\n  }\n}\n\nfragment profileTab_CoachProfileFragment on CoachProfile {\n  profileData {\n    socials {\n      linkedIn\n      facebook\n      twitter\n      website\n      others\n    }\n    description\n    jobTitles\n    quote\n    avatar {\n      id\n      url\n      thumbnail\n    }\n    basicPersonal {\n      lastName\n      firstName\n      title\n      salutation\n      phoneNumber\n      email\n    }\n    certificateAnswer\n    certificateFileIds {\n      id\n      name\n    }\n    coachingStrongPointsTopics\n    digitalAffinity1\n    digitalAffinity2\n    educationFreeText\n    educationMoreThan150h\n    languages\n    methods\n    personalPhilosophyCoachingStyle\n    personalPhilosophyVisionMission\n    referencesPublications\n    referencesCoachingExperienceIds {\n      id\n      name\n    }\n    studies\n    experience {\n      branches\n      branchesSteps\n      coachingFileIds {\n        id\n        name\n      }\n      coachingHours\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c75ce4d0a7a88e3a31313b28897ec2c";

export default node;
